import { useRouter } from "next/router";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Paragraph16Bold } from "../../../../../common/Typography/Paragraph16";
import { Paragraph14Regular } from "../../../../../common/Typography/Paragraph14";
import { routes } from "../../../../../routes";
import Icon from "../../../../../common/components/Icon/Icon";
import React from "react";

const Container = styled.div`
  display: grid;
  row-gap: 21px;
  justify-content: center;
  align-items: center;
`;

const Option = styled.div`
  background: ${({ theme }) => theme.lightBackgroundColor};
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 29px 22px 25px 22px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    max-width: 332px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileM}) {
    max-width: 282px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileS}) {
    max-width: 232px;
  }
`;

const Title = styled(Paragraph16Bold)`
  width: 100%;
  padding-bottom: 2.7px;
`;

const Description = styled(Paragraph14Regular)`
  width: 100%;
  padding-bottom: 22px;
  opacity: 0.7;
`;

const SelectLink = styled(Paragraph16Bold)`
  width: 100%;
  color: ${({ theme }) => theme.accent.light};
  cursor: pointer;
  text-decoration: none;
`;

const IconContainer = styled.div`
  margin: 0 auto;
  width: 60px;
  height: 60px;
  padding-bottom: 16px;
`;

const SignupOptionsMobile = () => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <Container>
      <Option onClick={() => router.push(routes.auth.join.signupArtist)}>
        <IconContainer>
          <Icon size="60px" name="signupArtist" />
        </IconContainer>
        <Title>{t("signup-box-artist-title")}</Title>
        <Description>{t("signup-box-artist-description")}</Description>
        <SelectLink>{t("signup-box-select-link")}</SelectLink>
      </Option>
      <Option onClick={() => router.push(routes.auth.join.signupUser)}>
        <IconContainer>
          <Icon size="60px" name="signupCollector" />
        </IconContainer>
        <Title>{t("signup-box-collector-title")}</Title>
        <Description>{t("signup-box-collector-description")}</Description>
        <SelectLink>{t("signup-box-select-link")}</SelectLink>
      </Option>
    </Container>
  );
};

export default SignupOptionsMobile;
